import styled from 'styled-components'
import { BasicButton } from '@sevenrooms/ui-kit/form'

// Exceptional button (existing ui kit component doesnt serve required purpose), requirement from the design team
export const OtherAvailabilityLinkButton = styled(BasicButton)`
  color: ${props => props.theme.colors.primaryFont};
  font: ${props => props.theme.textStyles.body1Bold};
  text-decoration: underline !important;

  &:focus,
  &:hover {
    font-weight: 600;
  }
`
